import { ToggleSettings } from './types';

const switcherBase = {
  width: 4,
  height: 4,
  borderRadius: 4,
  backgroundColor: 'white.main',
  borderWidth: 1,
  borderStyle: 'solid',
};
export const toggleSettings: ToggleSettings = {
  componentVariants: {
    color: {
      prop: 'colorVariant',
      variants: {
        'primary-active-on': {
          backgroundColor: 'success.main',
        },
        'primary-active-off': {
          backgroundColor: 'gray.light',
        },
        'primary-disabled-on': {
          backgroundColor: 'success.light',
        },
        'primary-disabled-off': {
          backgroundColor: 'white.dark',
        },
        'reversed-active-on': {
          backgroundColor: 'success.main',
        },
        'reversed-active-off': {
          backgroundColor: 'white.main',
        },
        'reversed-disabled-on': {
          backgroundColor: 'success.light',
        },
        'reversed-disabled-off': {
          backgroundColor: 'white.main',
        },
      },
    },
    baseColor: {
      prop: 'baseColor',
      variants: {
        'primary-active': {
          backgroundColor: 'gray.light',
        },
        'reversed-active': {
          backgroundColor: 'white.main',
        },
        'primary-disabled': {
          backgroundColor: 'white.dark',
        },
        'reversed-disabled': {
          backgroundColor: 'white.main',
        },
      },
    },
    size: {
      prop: 'size',
      variants: {
        medium: {
          fontSize: 0,
          fontFamily: 'secondary',
          height: 4,
          width: 6,
          borderRadius: 4,
          paddingRight: 4,
          paddingLeft: 4,
          boxSizing: 'border-box',
        },
      },
    },
    text: {
      prop: 'textVariant',
      variants: {
        'primary-active-on': {
          color: 'white.main',
        },
        'primary-active-off': {
          color: 'white.main',
        },
        'primary-disabled-on': {
          color: 'white.main',
        },
        'primary-disabled-off': {
          color: 'gray.main',
        },
        'reversed-active-on': {
          color: 'white.main',
        },
        'reversed-active-off': {
          color: 'success.dark',
        },
        'reversed-disabled-on': {
          color: 'white.main',
        },
        'reversed-disabled-off': {
          color: 'gray.main',
        },
      },
    },
    switcher: {
      prop: 'toggleState',
      variants: {
        'primary-active-on': {
          borderColor: 'success.dark',
          ...switcherBase,
        },
        'primary-active-off': {
          borderColor: 'success.dark',
          ...switcherBase,
        },
        'primary-disabled-on': {
          borderColor: 'success.light',
          ...switcherBase,
        },
        'primary-disabled-off': {
          borderColor: 'gray.light',
          ...switcherBase,
        },
        'reversed-active-on': {
          borderColor: 'success.dark',
          ...switcherBase,
        },
        'reversed-active-off': {
          borderColor: 'success.dark',
          ...switcherBase,
        },
        'reversed-disabled-on': {
          borderColor: 'success.light',
          ...switcherBase,
        },
        'reversed-disabled-off': {
          borderColor: 'gray.light',
          ...switcherBase,
        },
      },
    },
  },
};
